const MIME_EXTENSION: Record<string, string> = {
    'application/pdf': 'pdf',
    'audio/aac': 'aac',
    'audio/mpeg': 'mp3',
    'audio/ogg': 'ogg',
    'audio/webm': 'webm',
    'image/gif': 'gif',
    'image/jpeg': 'jpg',
    'image/png': 'png',
    'image/webp': 'webp',
    'video/mp4': 'mp4',
    'video/webm': 'webm',
};

export const extensionFromMimeType = (mimeType: string): string =>
    MIME_EXTENSION[mimeType] ?? mimeType.split('/').pop()?.split('+')[0] ?? 'bin';

type DeriveChatMediaFileNameParams = {
    explicitFileName?: string | null;
    baseName?: string;
    fileExtension?: string;
    mimeType?: string;
    mediaType?: string;
    fallbackId: string;
};

// Shared filename derivation for inbound (Meta webhook / media job) and outbound (upload + sendMessage)
// paths. Meta only sends an explicit `filename` for documents; images/audio/video/sticker need a
// mime-derived extension. Outbound uploads hand back `name` (sans extension) + `fileExtension`.
export const deriveChatMediaFileName = ({
    baseName,
    explicitFileName,
    fallbackId,
    fileExtension,
    mediaType,
    mimeType,
}: DeriveChatMediaFileNameParams): string => {
    if (explicitFileName?.trim()) return explicitFileName.trim();

    if (baseName?.trim()) {
        const trimmedBase = baseName.trim();
        if (fileExtension && !trimmedBase.toLowerCase().endsWith(`.${fileExtension.toLowerCase()}`)) {
            return `${trimmedBase}.${fileExtension}`;
        }
        if (trimmedBase.includes('.')) return trimmedBase;
        if (fileExtension) return `${trimmedBase}.${fileExtension}`;
        if (mimeType) return `${trimmedBase}.${extensionFromMimeType(mimeType)}`;
        return trimmedBase;
    }

    const extension = mimeType ? extensionFromMimeType(mimeType) : 'bin';
    const prefix = mediaType ?? 'attachment';
    const safeSuffix = fallbackId.replace(/[^a-zA-Z0-9]/g, '').slice(-8) || 'download';
    return `${prefix}-${safeSuffix}.${extension}`;
};
